import App from "./App"
import ReactDOM from 'react-dom/client'
import './index.css'


const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)